import { Themed, useThemeUI } from 'theme-ui'
import { DynamicSparkIcon } from '../../elements/spark-icons/dynamic-spark-icon'
import { Link } from '@uswitch/ev-core/react'

const getStyles = element => `compounds.link-with-label.${element}`

export default ({ text, title, label, description, icon, action }) => {
  const { theme } = useThemeUI()

  return (
    <div sx={{ variant: getStyles('wrapper') }}>
      <If condition={label || description}>
        <div sx={{ variant: getStyles('column') }}>
          <Themed.h5>{label}</Themed.h5>
          <Themed.p>{description}</Themed.p>
        </div>
      </If>
      <Link
        className={action === '/account/signin' ? 'js-account-origin js-open-o-signin' : ''}
        href={action}
        title={title}
        sx={{ variant: getStyles('anchor') }}
      >
        <If condition={icon}>
          <DynamicSparkIcon
            glyph={icon}
            size={theme.compounds['link-with-label']?.icon?.size || 'md'}
          />
        </If>
        <span>{text}</span>
      </Link>
    </div>
  )
}
